import React, { Component } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { GeoAltFill } from 'react-bootstrap-icons';

class WordChartClues extends Component {
    render() {
        const popover = (
            <Popover className="popover-basic">
                <Popover.Title as="h3">Word Chart Clues</Popover.Title>
                <Popover.Content>
                    <img src="https://res.cloudinary.com/dqykhzxtl/image/upload/v1603320139/virtual-time-travel/Word_Chart_Clues_ea0g8z.jpg" className="popover-images" alt="Word Chart Clues" />
                </Popover.Content>
            </Popover>
        );

        return (
            <OverlayTrigger
                trigger="click"
                placement="auto"
                overlay={popover}
                rootClose={true}
                transition={false}
                onToggle={() => this.setState({ error: null })}
            >
                <div className="game-icons years-alpha" style={this.props.positioning}>
                    <GeoAltFill alt="Word Chart Clues" />
                </div>
            </OverlayTrigger>
        )
    }
}

export default WordChartClues
